var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCasavoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.99 17.82c1.18 4.06 5.01 7.03 9.17 7.12 1.25.04 2.58-.16 3.82-.61.13-.05.12-.24-.02-.27-3.49-.76-6.49-3.38-7.24-6.95-.69-3.28.31-6.64 2.04-9.44.28-.46.57-.9.91-1.34.12-.16.21-.31.43-.26.21.05.23.23.3.53.7 3.05 3.63 5.34 6.88 5.43a.2.2 0 0 0 .2-.2V5.29c0-.14-.11-.24-.24-.24h-6.76c-4.08.04-7.57 2.53-9.08 6.06 0 0-1.59 3.01-.39 6.72Z"
})));
export default SvgCasavoIcon;